import React from 'react';
import { I18n } from 'aws-amplify';
import history from 'src/history';
import { TextLink } from 'copilot-design-system';

type Only<T, U> = {
  [P in keyof T]: T[P];
} & {
  [P in keyof U]?: never;
};
type Either<T, U> = Only<T, U> | Only<U, T>;
interface AuthLinkActionButton {
  onClick: () => void;
}
interface AuthLinkActionWithHref {
  href: string;
}

// auth link button should have href or onClick prop provided.
type Props = Either<AuthLinkActionWithHref, AuthLinkActionButton> & {
  linkText: string;
  className?: string;
};

export const AuthLinkActionButton: React.FC<Props> = ({
  className,
  onClick,
  linkText,
  href,
}) => {
  const handleClick = () => {
    if (href) {
      history.push(href);
    }
    onClick?.();
  };
  return (
    <div
      className={className}
      style={{
        justifyContent: 'center',
      }}
    >
      <TextLink
        className="text-gray-small text-[13px]"
        onClick={handleClick}
        variant="minimal"
      >
        {I18n.get(linkText)}
      </TextLink>
    </div>
  );
};
